import { ColumnDef } from '@tanstack/react-table';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import JobStageModel from 'components/modals/JobStageModel';
import { useState } from 'react';
import { JobStage } from 'services/api/jobStage';
import { DELETE_JOB_STAGE } from 'services/api/jobStage';
import { useQueryClient } from 'react-query';

const handleDelete = async (customerId: string) => {
  try {
    await DELETE_JOB_STAGE(customerId);
  } catch (error) {
    console.error('Error deleting customer:', error);
  }
};

export const createJobStageColumns = (
  canEdit = false,
  canDelete = false
): ColumnDef<JobStage>[] => [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row: { original } }) => {
      const name = original.name;
      return (
        <div className="d-flex align-items-center">
          <div>{name}</div>
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '25%' }, className: 'ps-0' },
      cellProps: { className: 'white-space-nowrap ps-0' }
    }
  },
  {
    accessorKey: 'Action',
    header: 'Action',
    id: 'leadDropdown',
    cell: ({ row: { original } }) => {
      const jobStageId = original.id;
      const navigate = useNavigate();
      const [showModel, setShowModel] = useState(false);
      const queries = useQueryClient();

      const handleDeleteClick = async (jobStageId: string) => {
        try {
          await handleDelete(jobStageId);
          queries.invalidateQueries('get_jobStage');
          navigate('/home/apps/job-stage');
        } catch (error) {
          console.error('Error handling delete:', error);
        }
      };

      if (!canEdit && !canDelete) {
        return null;
      }

      return (
        <>
          <RevealDropdownTrigger>
            <RevealDropdown>
              <>
                {canEdit && (
                  <>
                    <Dropdown.Item
                      eventKey="2"
                      onClick={() => setShowModel(true)}
                    >
                      Edit
                    </Dropdown.Item>
                    {canDelete && <Dropdown.Divider />}
                  </>
                )}
                {canDelete && (
                  <Dropdown.Item
                    eventKey="4"
                    className="text-danger"
                    onClick={() => handleDeleteClick(jobStageId)}
                  >
                    Delete
                  </Dropdown.Item>
                )}
              </>
            </RevealDropdown>
          </RevealDropdownTrigger>

          {showModel && (
            <JobStageModel
              show={showModel}
              handleClose={() => setShowModel(false)}
              isEditing
              jobStage={original}
            />
          )}
        </>
      );
    },
    meta: {
      cellProps: {
        className: 'text-end pe-0 ps-4'
      }
    }
  }
];
